import College from "src/models/College";
import Department from "src/models/Department";
import Faculty from "src/models/Faculty";
import { CONSTANTS } from "src/CONSTANTS";

export class Api {
    public static getEndPoint() {
        //return "http://devavrata.ddns.net:9000/api";
        return CONSTANTS.API_ENDPOINT;
    }

    public static getTestID() {
        return "89";
    }

    public static getScopusID() {
        return "56320593400";
    }

}

export function getCollegeStats() {
    const data = []
    
    //genenerate random data
    for (let i = 0;i< 10;i++){
        const count = Math.floor(Math.random() * 100000); 
        const college = new College(i,"college_" + i,count)
        data.push(college)
    }

    return data;
}

export function getDepartmentStats() {
    const data = []
    
    //genenerate random data
    for (let i = 0;i< 10;i++){
        const count = Math.floor(Math.random() * 100000); 
        const college = new Department(i,"department_" + i,count)
        data.push(college)
    }

    return data;
}

export function getFacultyStats() {
    const data = []
    
    //genenerate random data
    for (let i = 0;i< 20;i++){
        const count = Math.floor(Math.random() * 100000); 
        const college = new Faculty(i,"faculty_" + i,count)
        data.push(college)
    }

    return data;
}



// WEBPACK FOOTER //
// ./src/core/api.ts